import { BigNumber } from "@ethersproject/bignumber";
import { ethers } from "ethers";
import { ERC20_ABI } from "./abis";
import { isWrappedNativeToken } from "./nativeToken";
import { ChecksumAddress, SupportedChainId } from "@silo/types";
import { FallbackProvider } from "@ethersproject/providers";

const erc20BalanceOf = (
  addressOfToken: ChecksumAddress,
  account: ChecksumAddress,
  provider: FallbackProvider
): Promise<BigNumber> => {
  const erc20Contract = new ethers.Contract(
    addressOfToken,
    ERC20_ABI,
    provider
  );
  return erc20Contract.balanceOf(account);
};

export const balanceOf = (
  address: ChecksumAddress,
  account: ChecksumAddress,
  provider: FallbackProvider,
  chainId: SupportedChainId
): Promise<BigNumber> => {
  if (isWrappedNativeToken(chainId)(address)) {
    return provider.getBalance(account);
  }

  return erc20BalanceOf(address, account, provider);
};
